var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.5,
    height: 38,
    viewBox: "0 0 35.5 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow-right",
    d: "M16.38,12.249a.9.9,0,0,1,1.241,1.3l-6.9,6.548H28.7a.9.9,0,0,1,0,1.8H10.745l6.875,6.548a.9.9,0,1,1-1.241,1.3L8.527,22.273a1.8,1.8,0,0,1,.016-2.561Z",
    transform: "translate(4.9 -2.501)",
    fill: "#123663"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    y2: 38,
    transform: "translate(0)",
    fill: "none",
    stroke: "#123663",
    strokeWidth: 2,
    strokeDasharray: "2 4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButtonIcon);
export default __webpack_public_path__ + "static/media/backButtonIcon.b027d921a7ebd6a23f74bf115605552b.svg";
export { ForwardRef as ReactComponent };